export const lbTokg = lb => lb * 0.4535924
export const kgTolb = km => km * 2.2046226
export const inTocm = inch => inch * 2.54
export const cnToin = cm => cm * 0.3937008
export const lbToton = lb => lb * 0.4535924 / 1000 // 磅 -> 吨
export const inTometer = inch => inch * 2.54 / 100 // 英寸->米
export const inToMile = inch => inch * 0.0006214 // 米->英寸